function ETHLogo({
  height = 88,
  width = 54,
  fill = 'white',
}: {
  height?: number;
  width?: number;
  fill?: string;
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 54 88" fill="none">
      <path d="M26.9927 60.7835L53.9854 44.8194L26.9927 0L0 44.8194L26.9927 60.7835Z" fill={fill} />
      <path d="M26.9927 88L54 49.9408L26.9927 65.8903L0 49.9408L26.9927 88Z" fill={fill} />
    </svg>
  );
}

export default ETHLogo;
